import React from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { OneInchNetwork } from '@api';

const NetworkOption = ({ network, small }: { network: OneInchNetwork; small?: boolean }) => {
  if (small) {
    return (
      <div
        className={classNames('flex gap-2 items-center text-left flex-grow', {
          'text-sm': small,
        })}
      >
        <ImageProxy
          width={36}
          height={36}
          className={classNames('icon', {
            'icon-lg': !small,
          })}
          src={network.attributes.logoUrl}
          alt={network.attributes.name}
        />

        {network.attributes.name}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'flex gap-2 items-center hover:bg-primary-50 flex-grow border-b border-primary-100 p-4',
      )}
    >
      <ImageProxy
        width={36}
        height={36}
        className="icon"
        src={network.attributes.logoUrl}
        alt={network.attributes.name}
      />

      {network.attributes.name}
    </div>
  );
};

export default NetworkOption;
